import React, { useEffect, useState } from "react";
import { dropdownData, getRecords } from "../../../services/api.service";
import { Col } from "reactstrap";
import { useLocation } from "react-router-dom";
import MultiSelectDropInput from "./MultiSelect-Input/MultiSelectDropInput";
import SingleSelectInput from "./SingleSelect-Input/SingleSelectInput";

const DashDropdown = () => {
  const location = useLocation();

  // Dropdowns
  const [projectSelect, setProjectSelect] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [warehouseSelect, setWarehouseSelect] = useState([]);

  const [categorySelect, setCategorySelect] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [warehouseTypeOptions, setWarehouseTypeOptions] = useState([]);

  const [warehouseTypeSelect, setWarehouseTypeSelect] = useState(
    warehouseTypeOptions.filter((option) => option.value !== "select-all")
  );
  const [costAndQtySelect, setCostAndQtySelect] = useState({
    label: "QTY",
    value: "qty",
  });
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [allProject, setAllProject] = useState([]);
  const [allWarehouseTypes, setAllWarehouseTypes] = useState([]);
  const [allWarehouse, setAllWarehouse] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [costAndQTYOptions, setCostAndQTYOptions] = useState([
    { label: "QTY", value: "qty" },
  ]);
  const [currentRole, setCurrentRole] = useState('');

  useEffect(() => {
    const checkRole = () => {
      const userDetails = JSON.parse(localStorage.getItem("userDetails") || '{}');
      const role = userDetails?.role_masters?.role_name || '';
      setCurrentRole(role);
      
      if (role?.toLowerCase() === "cost user".toLowerCase()) {
        setCostAndQTYOptions([
          { label: "QTY", value: "qty" },
          { label: "Cost", value: "cost" },
        ]);
      } else {
        setCostAndQTYOptions([{ label: "QTY", value: "qty" }]);
      }
    };

    checkRole();

    const handleStorageChange = (e) => {
      if (e.key === "userDetails") {
        checkRole();
      }
    };
    const handleRoleUpdate = () => {
    checkRole();
  };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('userDetailsUpdated', handleRoleUpdate);
    window.addEventListener('roleUpdated', handleRoleUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userDetailsUpdated', handleRoleUpdate);
      window.removeEventListener('roleUpdated', handleRoleUpdate);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      resetDropdowns();
    }
    const fetchData = async () => {
      setLoading(true);

      await getProjectDropdownData();
      await getCategoryDropdownData();
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (warehouseTypeSelect.length > 0) {
      getWarehouseDropData(warehouseTypeSelect.map((opt) => opt.value));
    }
  }, [projectSelect, warehouseTypeSelect]);
  useEffect(() => {
    getWarehouseTypeDropData();
  }, [projectSelect]);

  const resetDropdowns = () => {
    setProjectSelect(projectOptions.filter((option) => option.value));
    setWarehouseSelect(warehouseSelect.filter((option) => option.value));
    setCategorySelect(categoryOptions.filter((option) => option.value));
    setWarehouseTypeSelect(
      warehouseTypeOptions.filter((option) => option.value)
    );
    setCostAndQtySelect({ label: "QTY", value: "qty" });
  };

  useEffect(() => {
    if (
      !allProject.length ||
      !allWarehouse.length ||
      !allWarehouseTypes.length ||
      !allCategory.length
    ) {
      return;
    }

    const dash_details = {
      project_id:
        Array.isArray(projectSelect) && projectSelect.length > 0
          ? projectSelect
              .filter((pro) => pro?.value !== "select-all")
              .map((opt) => opt?.value)
          : allProject.map((opt) => opt?.value),
      warehouse_type:
        Array.isArray(warehouseTypeSelect) &&
        warehouseTypeSelect.length > 0 &&
        projectSelect.length > 0
          ? warehouseTypeSelect
              .filter((pro) => pro?.value !== "select-all")
              .map((opt) => opt?.value)
          : allWarehouseTypes.map((opt) => opt?.value),
      warehouse_id:
        Array.isArray(warehouseSelect) &&
        warehouseSelect.length > 0 &&
        projectSelect.length > 0 &&
        warehouseTypeSelect.length > 0
          ? warehouseSelect
              .filter((pro) => pro?.value !== "select-all")
              .map((opt) => opt?.value)
          : allWarehouse.map((opt) => opt?.value),
      category_id:
        Array.isArray(categorySelect) && categorySelect.length > 0
          ? categorySelect
              .filter((pro) => pro?.value !== "select-all")
              .map((opt) => opt?.value)
          : allCategory.map((opt) => opt?.value),
      type: costAndQtySelect?.value || "",
    };

    localStorage.setItem("dashboard_details", JSON.stringify(dash_details));
    const event = new Event("dashboardUpdate");
    window.dispatchEvent(event);
  }, [
    projectSelect,
    warehouseTypeSelect,
    warehouseSelect,
    categorySelect,
    costAndQtySelect,
  ]);

  const getProjectDropdownData = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("userDetails"))?.id;
      const payload = {
        modelName: "projects",
        relations: [
          {
            module: "project_access",
            moduleAs: "project_access",
            isModuleWhereConditionRequired: true,
            required: true,
          },
        ],
        whereCondition: {
          is_active: true,
        },
        moduleWhereCondition: {
          user_id: userId,
          access: true,
          is_active: true,
        },
      };
      const response = await getRecords(payload, "/listProject");
      if (response?.data?.length > 0) {
        const dropdownResponseData = await dropdownData(
          response.data,
          "project_name"
        );

        const flattenedOptions = dropdownResponseData.reduce(
          (acc, item) => acc.concat(item.options),
          []
        );
        setProjectOptions([...flattenedOptions]);
        setProjectSelect([...flattenedOptions]);
        setAllProject(flattenedOptions);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };
  const getWarehouseTypeDropData = async () => {
    if (!projectSelect.length) {
      return;
    }
    try {
      const projectData = JSON.parse(
        localStorage.getItem("dashboard_details")
      )?.project_id;

      const payload = {
        project_id:
          projectSelect?.length > 0
            ? projectSelect.map((op) => op.value)
            : projectData,
      };
      const response = await getRecords(
        payload,
        "/dashboard/getWarehouseTypesByProject"
      );

      if (response?.data?.length > 0) {
        const modifiedData = {
          ...response,
          data: response.data.map((item) => ({
            id: item.type,
            type_name: item.type_name,
          })),
        };

        const dropdownResponseData = await dropdownData(
          modifiedData.data,
          "type_name"
        );
        const flattenedOptions = dropdownResponseData.reduce(
          (acc, item) => acc.concat(item.options),
          []
        );
        setWarehouseTypeOptions([...flattenedOptions]);
        setWarehouseTypeSelect([...flattenedOptions]);
        setAllWarehouseTypes(flattenedOptions);
      } else {
        setWarehouseTypeOptions([]);
        setWarehouseTypeSelect([]);
        setWarehouseOptions([]);
        setWarehouseSelect([]);
      }
    } catch (error) {
      console.error("Error fetching warehouse type data:", error);
    }
  };
  // Fetch warehouse dropdown data based on selected warehouse type
  const getWarehouseDropData = async (type) => {
    if (!projectSelect.length) {
      return;
    }
    try {
      const projectData = JSON.parse(
        localStorage.getItem("dashboard_details")
      )?.project_id;

      const payload = {
        project_id:
          projectSelect?.length > 0
            ? projectSelect.map((op) => op.value)
            : projectData,

        warehouse_type: type?.length == 1 ? type[0] : null,
      };
      const response = await getRecords(
        payload,
        "/dashboard/getProjectWiseWarehouseDropdownListing"
      );
      if (response?.data?.length > 0) {
        const dropdownResponseData = await dropdownData(
          response.data,
          "warehouse_name"
        );
        const flattenedOptions = dropdownResponseData.reduce(
          (acc, item) => acc.concat(item.options),
          []
        );
        setWarehouseOptions([...flattenedOptions]);
        setWarehouseSelect([...flattenedOptions]); // Clear the selected warehouse data
        setAllWarehouse(flattenedOptions);
      } else {
        setWarehouseOptions([]);
        setWarehouseSelect([]);
      }
    } catch (error) {
      console.error("Error fetching warehouse data:", error);
    }
  };

  // Fetch category dropdown data
  const getCategoryDropdownData = async () => {
    try {
      const payload = {
        modelName: "category_masters",
        relations: [
          { module: "user_masters", moduleAs: "createdBy" },
          { module: "user_masters", moduleAs: "updatedBy" },
        ],
      };
      const response = await getRecords(payload, "/listCategory");
      if (response?.data?.length > 0) {
        const dropdownResponseData = await dropdownData(
          response.data,
          "category_name"
        );
        const flattenedOptions = dropdownResponseData.reduce(
          (acc, item) => acc.concat(item.options),
          []
        );
        setCategoryOptions([...flattenedOptions]);
        setCategorySelect([...flattenedOptions]);
        setAllCategory(flattenedOptions);
      } else {
        setCategoryOptions([]);
        setCategorySelect([]);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  // Handle project selection
  const handleProjectSelect = (options) => {
    if (options?.includes("select-all")) {
      // If "select-all" is selected, set all projectOptions except "select-all"
      const filteredOptions = projectOptions.filter(
        (option) => option.value !== "select-all"
      );
      setProjectSelect(projectOptions);
      getWarehouseTypeDropData();
    } else {
      // Compare `options` IDs with `projectOptions` and return matching objects
      const selectedProjects = projectOptions.filter((pro) =>
        options.includes(pro.value)
      );

      setProjectSelect(selectedProjects);
      if (options.length > 0) {
        // getWarehouseTypeDropData();
      } else {
        setWarehouseTypeOptions([]);
        setWarehouseTypeSelect([]);
        setWarehouseOptions([]);
        setWarehouseSelect([]);
      }
    }
  };

  // Handle warehouse type selection
  const handleWarehouseTypeSelect = (options) => {
    if (options?.includes("select-all")) {
      // If "select-all" is selected, set all projectOptions except "select-all"
      const filteredOptions = warehouseTypeOptions.filter(
        (option) => option.value !== "select-all"
      );

      setWarehouseTypeSelect(warehouseTypeOptions);
      getWarehouseDropData(filteredOptions.map((opt) => opt?.value));
    } else {
      const selectedwarehouseType = warehouseTypeOptions.filter((pro) =>
        options.includes(pro.value)
      );

      setWarehouseTypeSelect(selectedwarehouseType);
      if (options.length > 0) {
        getWarehouseDropData(options);
      } else {
        setWarehouseOptions([]); // Clear warehouse options
        setWarehouseSelect([]); // Clear selected warehouse data
      }
    }
  };

  // Handle warehouse selection
  const handleWarehouseSelect = (options) => {
    if (options?.includes("select-all")) {
      // If "select-all" is selected, set all projectOptions except "select-all"
      const filteredOptions = warehouseOptions.filter(
        (option) => option.value !== "select-all"
      );
      setWarehouseSelect(warehouseOptions);
    } else {
      const selectedwarehouses = warehouseOptions.filter((pro) =>
        options.includes(pro.value)
      );

      setWarehouseSelect(selectedwarehouses);
    }
  };

  // Handle category selection
  const handleCategorySelect = (options) => {
    if (options?.includes("select-all")) {
      // If "select-all" is selected, set all projectOptions except "select-all"
      const filteredOptions = categoryOptions.filter(
        (option) => option.value !== "select-all"
      );
      setCategorySelect(categoryOptions);
    } else {
      const selectedCategory = categoryOptions.filter((pro) =>
        options.includes(pro.value)
      );

      setCategorySelect(selectedCategory);
    }
  };

  // Handle cost and quantity selection
  const handleCostAndQTYSelect = (options) => {
    setCostAndQtySelect(options);
  };

  return (
    <>
      {(location.pathname === "/dashboard" ||
        location.pathname === "/project-details" ||
        location.pathname === "/warehouse-details" ||
        location.pathname === "/available-stocks" ||
        location.pathname === "/category-wise-stocks" ||
        location.pathname === "/inward-outward-wise-stocks" ||
        location.pathname === "/installation-report" ||
        location.pathname === "/commissioning-report") && (
        <div
          className="d-flex align-items-center pb-2 gap-3"
          style={{ width: "90%", marginBottom: "8px" }}
        >
          <Col md={2}>
            <MultiSelectDropInput
              localkey="project_id"
              value={
                projectSelect.some((item) => item.value === "select-all")
                  ? [{ value: "select-all", label: "Select All" }]
                  : projectSelect
              }
              options={projectOptions}
              // onMultiSelect={handleProjectSelect}
              onMultiSelect={(selected) => handleProjectSelect(selected)}
              isClearable={true}
              label="Project"
              dropdownId="dropdown1"
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              loading={loading}
              setLoading={setLoading}
            />
          </Col>
          <Col md={2}>
            <MultiSelectDropInput
              localkey="warehouse_type"
              value={
                warehouseTypeSelect.some((item) => item.value === "select-all")
                  ? [{ value: "select-all", label: "Select All" }]
                  : warehouseTypeSelect
              }
              options={warehouseTypeOptions}
              onMultiSelect={(selected) => handleWarehouseTypeSelect(selected)}
              isClearable={true}
              label="Warehouse Type"
              dropdownId="dropdown2"
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              loading={loading}
              setLoading={setLoading}
            />
          </Col>
          <Col md={2}>
            <MultiSelectDropInput
              localkey="warehouse_id"
              value={
                warehouseSelect.some((item) => item.value === "select-all")
                  ? [{ value: "select-all", label: "Select All" }]
                  : warehouseSelect
              }
              options={warehouseOptions}
              // onMultiSelect={handleWarehouseSelect}
              onMultiSelect={(selected) => handleWarehouseSelect(selected)}
              placeholder="Warehouse"
              isClearable={true}
              isDisabled={warehouseTypeSelect.length === 0}
              label="Warehouse"
              dropdownId="dropdown3"
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              loading={loading}
              setLoading={setLoading}
            />
          </Col>
          <Col md={2}>
            <MultiSelectDropInput
              localkey="category_id"
              value={
                categorySelect.some((item) => item.value === "select-all")
                  ? [{ value: "select-all", label: "Select All" }]
                  : categorySelect
              }
              options={categoryOptions}
              // onMultiSelect={handleCategorySelect}
              onMultiSelect={(selected) => handleCategorySelect(selected)}
              isClearable={true}
              label="Category"
              dropdownId="dropdown4"
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              loading={loading}
              setLoading={setLoading}
            />
          </Col>
          <Col md={2}>
            <SingleSelectInput
              value={costAndQtySelect}
              options={costAndQTYOptions}
              onSelect={handleCostAndQTYSelect}
              placeholder="Type"
              isClearable={true}
              dropdownId="dropdown5"
              activeDropdown={activeDropdown}
              setActiveDropdown={setActiveDropdown}
              label="Type"
              loading={loading}
            />
          </Col>
        </div>
      )}
    </>
  );
};

export default DashDropdown;
